function formatter(val) {
  const confirmedValue = isNaN(val) ? val : Number(val);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    useGrouping: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(Number(confirmedValue.toFixed(2)));
}

export default formatter;